import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { HeaderService } from '../../services/header.service';
import { ContactsComponent } from './contacts/contacts.component';
import { CompaniesComponent } from './companies/companies.component';
import { DealsComponent } from './deals/deals.component';
import * as CrmActions from '../../state/crm/crm.actions';

interface Tab {
  id: string;
  label: string;
}

@Component({
  selector: 'app-crm',
  standalone: true,
  imports: [CommonModule, FormsModule, ContactsComponent, CompaniesComponent, DealsComponent],
  templateUrl: './crm.component.html',
  styleUrl: './crm.component.scss'
})
export class CrmComponent implements OnInit {
  @ViewChild(ContactsComponent) contactsComponent: ContactsComponent;
  @ViewChild(CompaniesComponent) companiesComponent: CompaniesComponent;
  @ViewChild(DealsComponent) dealsComponent: DealsComponent;

  tabs: Tab[] = [
    { id: 'contacts', label: 'Contacts' },
    { id: 'companies', label: 'Companies' },
    { id: 'deals', label: 'Deals' },
  ];

  activeTab: string = 'contacts'; // Default active tab
  searchQuery: string = '';

  constructor(
    private headerService: HeaderService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.headerService.setHeaderState('CRM', null, true);
    
    // Load all initial CRM data once from parent component
    this.store.dispatch(CrmActions.loadContacts({
      page: 1,
      perPage: 10
    }));
    
    this.store.dispatch(CrmActions.loadCompanies({
      page: 1,
      perPage: 10
    }));
    
    this.store.dispatch(CrmActions.loadDeals({
      page: 1,
      perPage: 10
    }));

    // Lookup data for selectors in modals (full lists)
    this.store.dispatch(CrmActions.loadContactsLookup());
    this.store.dispatch(CrmActions.loadCompaniesLookup());
  }

  setActiveTab(tabId: string): void {
    this.activeTab = tabId;
    this.searchQuery = ''; // Clear search when switching tabs
  }

  getTabClass(tabId: string): string {
    if (this.activeTab === tabId) {
      return 'bg-primary/10 text-primary';
    }
    return 'text-secondary hover:opacity-90';
  }

  getSearchPlaceholder(): string {
    switch (this.activeTab) {
      case 'contacts':
        return 'Search by name';
      case 'companies':
        return 'Search by name';
      case 'deals':
        return 'Search by name';
      default:
        return 'Search';
    }
  }

  getAddButtonText(): string {
    switch (this.activeTab) {
      case 'contacts':
        return 'Add Contact';
      case 'companies':
        return 'Add Company';
      case 'deals':
        return 'Add Deal';
      default:
        return 'Add New';
    }
  }

  handleSearch(): void {
    // Delegate search to the appropriate component based on active tab
    switch (this.activeTab) {
      case 'contacts':
        if (this.contactsComponent) {
          this.contactsComponent.searchReport();
        }
        break;
      case 'companies':
        if (this.companiesComponent) {
          this.companiesComponent.searchReport();
        }
        break;
      case 'deals':
        if (this.dealsComponent) {
          this.dealsComponent.searchReport();
        }
        break;
    }
  }

  handleAddNew(): void {
    // Handle add new based on active tab
    switch (this.activeTab) {
      case 'contacts':
        if (this.contactsComponent) {
          this.contactsComponent.addUser();
        }
        break;
      case 'companies':
        if (this.companiesComponent) {
          this.companiesComponent.addCompany();
        }
        break;
      case 'deals':
        if (this.dealsComponent) {
          this.dealsComponent.addDeal();
        }
        break;
    }
  }
}
